<template>
  <swiper
    class="swiper"
    :options="swiperOption"
    ref="swiper"
    :style="{ height: `${bannerHeight}px` }"
  >
    <swiper-slide v-for="item in list" :key="item.name">
      <div class="img-row">
        <img :src="item.img" alt="" />
      </div>
    </swiper-slide>
    <div slot="button-prev" class="swiper-button-prev" @click="prevBtn"></div>
    <div slot="button-next" class="swiper-button-next" @click="nextBtn"></div>
  </swiper>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    height: [String, Number],
    minHeight: {
      type: [String, Number],
      default: () => 200,
    },
  },
  data() {
    return {
      bannerHeight: this.height,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        // 滑动速度
        speed: 800,
        // 无限循环
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 当用户滑动图片后继续自动轮播
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.sliderHeight();
  },
  methods: {
    // 轮播图高度
    sliderHeight() {
      const that = this,
        min_height = that.minHeight;
      swiperHeight();
      window.onresize = () => {
        swiperHeight();
      };
      function swiperHeight() {
        let swiper_height = that.$refs.swiper.$el.offsetWidth;
        that.bannerHeight = (that.height / (1920 * 0.9)) * swiper_height;
        if (that.bannerHeight < min_height) that.bannerHeight = min_height;
      }
    },
    prevBtn() {
      this.swiper.slidePrev();
    },
    nextBtn() {
      this.swiper.slideNext();
    },
  },
};
</script>
<style lang="scss">
.swiper {
  width: 100%;
}
div[class^="swiper-button"] {
  color: rgba(255,255,255,.8);
  &:hover{
    color: rgba(255,255,255,1);
  }
}
</style>
